import { Box, Flex, Heading } from '@chakra-ui/react';
import React from 'react';

import { CreditFacilitySelect } from 'packages/credit-facility/ui/CreditFacilitySelect';

export const FundingRequestsViewTemplate = ({
  children,
  isCreditFacilitySelectDisabled,
}: {
  isCreditFacilitySelectDisabled: boolean;
  children: React.ReactNode;
}) => {
  return (
    <>
      <Flex justify="space-between">
        <Heading as="h2">Funding Request</Heading>
        <Box>
          <CreditFacilitySelect isDisabled={isCreditFacilitySelectDisabled} />
        </Box>
      </Flex>
      <Box mt="25px" padding="10px">
        {children}
      </Box>
    </>
  );
};
